import { useLanguage } from "../i18n";
import { LanguageToggle } from "./Header";

const Footer = () => {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();
  const links = [
    { href: "#services", label: t.nav.services, id: "footer-services" },
    { href: "#community", label: t.nav.community, id: "footer-community" },
    { href: "#gallery", label: t.nav.gallery, id: "footer-gallery" },
    { href: "#faq", label: "FAQ", id: "footer-faq" },
    { href: "#contact", label: t.nav.contact, id: "footer-contact" },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-white/10 bg-[#0A0B0E]"
    >
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 shadow-md">
                <img
                  src="/logo.jpg"
                  alt="Family Auto Sales — Committed to your satisfaction"
                  className="h-9 w-auto"
                />
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#9E9E9E]">
              {t.footer.tagline}
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="font-mono-accent text-[11px] uppercase tracking-widest text-[#6C757D]">
                {t.footer.langLabel}
              </span>
              <LanguageToggle />
            </div>
          </div>

          <div>
            <p className="font-mono-accent text-[11px] font-bold uppercase tracking-widest text-[#E63946]">
              {t.footer.explore}
            </p>
            <ul className="mt-4 space-y-2.5">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={l.id}
                    className="text-sm text-[#9E9E9E] transition-colors duration-300 hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono-accent text-[11px] font-bold uppercase tracking-widest text-[#E63946]">
              {t.footer.hoursTitle}
            </p>
            <p className="mt-4 font-mono-accent text-sm font-bold text-[#00F5D4]">
              {t.footer.hoursLine}
            </p>
            <p className="mt-1.5 font-mono-accent text-sm text-[#6C757D]">
              {t.footer.closedLine}
            </p>
          </div>
        </div>

        <h2
          aria-hidden="true"
          className="text-outline font-display pointer-events-none mt-16 select-none whitespace-nowrap text-center text-[13vw] font-black leading-none tracking-tight lg:text-[10rem]"
        >
          FAMILY AUTO
        </h2>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-[#6C757D]" data-testid="footer-copyright">
            © {year} Family Auto Sales. {t.footer.rights}
          </p>
          <p className="font-mono-accent text-[11px] uppercase tracking-widest text-[#6C757D]">
            {lang === "en" ? "Se Habla Español" : "We Speak English"}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
